module.exports = __webpack_public_path__ + "img/DSC_0101.d620e291.jpg";